/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-05 10:12:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-11 18:22:07
 * @FilePath: /dbrank_b/src/routes/cms/components/NavComponent/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import classnames from 'classnames';
import { colors } from '../confog';

const getTeeePath = (tree, id, path) => {
  for( let i = 0; i < tree.length; i++ ) {
    const ele = tree[i];
    const brandId = `${ele.brandId || ele.brand_id}`;
    const idStr = `${id}`;
    const innerPath = `${path}_${i}`;

    if (brandId === idStr) {
      return innerPath
    }
    if (Array.isArray(ele.children) && ele.children.length > 0) {
      const a = getTeeePath(ele.children, id, innerPath)
      if (a) {
        return a;
      }
    }
  }
}

class NavItem extends React.Component {

  constructor(props) {
    super(props);
    const {currentPath, deepIndex} = props;

    this.state = { 
      current: Number(currentPath[deepIndex]) || 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    const {currentPath, deepIndex} = this.props;
    // console.log('----',nextProps.currentPath, currentPath);
    if(nextProps.currentPath !== currentPath) {
      // console.log('11111');
      this.setState({
        current: currentPath[deepIndex],
      })
    }
  }
  render () {
    const { current } = this.state;
    const { list, deepIndex, parentKey='t', toggleNav, currentKey, currentPath } = this.props;

    return (
      <ul className={s.wrapper}>
        {list.map((item, index) => {
          const brandId = item.brandId || item.brand_id;
          const key = `${parentKey}_${index}`;
          return (
            <li key={key}  style={{
              backgroundColor: colors[deepIndex+1],
              border: `4px solid ${colors[deepIndex]}`,
              // padding: '0 2px',
          }}>
              <div
                className={classnames(
                  s.navList,
                  {
                    [s.active]: key === currentKey,
                    [s.hasChild]: item.children,
                    [s.hasChildExpand]: current === index
                  },
                )}
                onClick={() => {
                  this.setState({ current: index })
                  toggleNav(deepIndex, key, {
                    ...item,
                    brandId,
                  });
                }}
                style={{
                  paddingLeft: 20 + deepIndex * 20,
                  fontSize: deepIndex > 2 ? 12 : 14,
                  // boxShadow: `inset 0 0 10px ${colors[deepIndex]}`,
                }}>
                {item.brandName}
              </div>
              {item.children && item.children.length && (
                <div className={classnames(s.navItemWrapper, { [s.hide]: current !== index })}>
                  <NavItem
                    list={item.children}
                    deepIndex={deepIndex + 1}
                    parentKey={`${parentKey}_${index}`}
                    toggleNav={toggleNav}
                    currentKey={currentKey}
                    currentPath={currentPath}
                  />
                </div>
              )}
            </li>
          )
        })}
      </ul>
    )
  }
}

class NavComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentKey: 't_0',
      currentPath: [0]
    }
  }

  componentWillReceiveProps(nextProps){
    const { defaultBrand, tree } = this.props;
    if (nextProps.tree !== tree) {
      if(!(nextProps.tree.length === 0 && tree.length === 0)) {
        const currentKey = getTeeePath(nextProps.tree, defaultBrand, 't') || 't_0';
        const currentPath = currentKey.replace('t_', '').split('_');
        this.setState({
          currentKey,
          currentPath,
        })
      }
    }
  }

  toggleNav = (deepIndex, currentKey, data) => {
    const { onChange } = this.props;

    this.setState({
      currentKey,
    }, () => {
      onChange && onChange(data, deepIndex, currentKey);
    })
  }

  render() {
    const { tree } = this.props;
    const { currentKey, currentPath } = this.state;

    // console.log(currentPath);
    if (Array.isArray(tree) && tree.length > 0) {
      return (
        <div className={s.container}>
          <NavItem
            list={tree}
            deepIndex={0}
            parentKey="t"
            toggleNav={this.toggleNav}
            currentKey={currentKey}
            currentPath={currentPath}
          />
        </div>
      )
    }

    return (
      <div className={s.empty}>暂无数据</div>
    )
  }
}

export default withStyles(s)(NavComponent)



// WEBPACK FOOTER //
// src/routes/cms/components/NavComponent/index.js